import { render, staticRenderFns } from "./ReadPleasure.vue?vue&type=template&id=d154103c&"
import script from "./ReadPleasure.vue?vue&type=script&lang=ts&"
export * from "./ReadPleasure.vue?vue&type=script&lang=ts&"
import style0 from "./ReadPleasure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports